<template>
  <div id="app">
    <!-- Header -->
    <header class="site-header">
      <div class="header-left"></div>
      <div class="header-center">
        <h1 class="site-title">{{ $t('siteTitle') }}</h1>
      </div>
      <div class="header-right">
        <router-link to="/" class="nav-link">{{ $t('nav.home') }}</router-link>
        <router-link to="/galerija" class="nav-link">{{ $t('nav.gallery') }}</router-link>

        <!-- Hamburger for language selection -->
        <div class="language-menu">
          <button @click="toggleLangMenu" class="hamburger-btn" aria-label="Toggle languages">☰</button>
          <ul v-if="langMenuOpen" class="language-dropdown">
            <li v-for="lang in languages" :key="lang.code">
              <button @click="changeLanguage(lang.code)">
                {{ lang.label }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>

    <Breadcrumbs />

    <!-- Router View -->
    <router-view></router-view>

    <!-- Footer -->
    <footer class="site-footer">
      <div class="footer-section">
        <p><strong>{{ $t('contacts.ivana.name') }}</strong></p>
        <p>📞 {{ $t('contacts.ivana.phone') }}</p>
        <p>
          ✉️ {{ $t('contacts.ivana.emailLabel') }}
          <a href="mailto:ivana.gasparini7@gmail.com">ivana.gasparini7@gmail.com</a>
        </p>
      </div>

      <div class="footer-section">
        <p><strong>{{ $t('contacts.mario.name') }}</strong></p>
        <p>📞 {{ $t('contacts.mario.phone') }}</p>
      </div>

      <div class="footer-section address">
        <p><strong>{{ $t('address.title') }}</strong></p>
        <p>{{ $t('address.line1') }}</p>
        <p>{{ $t('address.line2') }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import Breadcrumbs from './components/AppBreadcrumbs.vue'; // Adjust path if needed
export default {
  name: 'App',
  data() {
    return {
      langMenuOpen: false,
      languages: [
        { code: 'en', label: 'EN' },
        { code: 'hr', label: 'HR' },
        { code: 'it', label: 'IT' },
        { code: 'sl', label: 'SL' },
        { code: 'de', label: 'DE' }
      ]
    };
  },
  methods: {
    toggleLangMenu() {
      this.langMenuOpen = !this.langMenuOpen;
    },
    changeLanguage(code) {
      this.$i18n.locale = code;
      this.langMenuOpen = false;
    }
  },
  components: {
  Breadcrumbs,
},

};
</script>

<style scoped>

#app {
  background-color: #e6f0ea; 
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


.site-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  background-color: #a8c0a0; 
  border-bottom: 1px solid #9bbf9b;
  position: relative;
  color: #2f3e46; 
}

.header-left,
.header-center,
.header-right {
  flex: 1;
}

.header-center {
  text-align: center;
}

.site-title {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
  color: #2f3e46; 
}

.header-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.nav-link {
  text-decoration: none;
  color: #2f3e46; 
  font-weight: 500;
}

.nav-link:hover {
  color: #4a6e58; 
}


.hamburger-btn {
  font-size: 1.5rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #2f3e46;
}

.language-menu {
  position: relative;
}

.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: #f0f4f8; 
  border: 1px solid #9bbf9b; 
  list-style: none;
  padding: 0.5rem 0;
  margin: 0;
  z-index: 1000;
  width: 80px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.language-dropdown li button {
  background: none;
  border: none;
  width: 100%;
  padding: 0.5rem 1rem;
  text-align: left;
  cursor: pointer;
  font-weight: 500;
  color: #2f3e46;
}

.language-dropdown li button:hover {
  background-color: #a8c0a0; 
  color: white;
}


.site-footer {
  border-top: 1px solid #9bbf9b;
  padding: 1rem 2rem 0 2rem;
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  color: #2f3e46;
  background-color: #a8c0a0; 
  margin-top: auto;
}

.footer-section {
  max-width: 30%;
}

.footer-section a {
  color: #2f3e46;
  text-decoration: none;
}

.footer-section a:hover {
  text-decoration: underline;
}


@media (max-width: 768px) {
  .site-header {
    flex-wrap: wrap;
  }

  .header-left,
  .header-center,
  .header-right {
    flex: 100%;
    text-align: center;
    margin-bottom: 0.5rem;
  }

  .header-right {
    justify-content: center;
    gap: 0.5rem;
  }

  .site-footer {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .footer-section {
    max-width: 100%;
  }
}
</style>


